import { useNotification } from '@/composables/useNotification';
import axios, { AxiosInstance } from 'axios';


const createAxiosInstance = (): AxiosInstance => {
    const instance = axios.create({
        baseURL: import.meta.env.VITE_API_URL,
        headers: {
            Accept: 'application/json',
        },
    });

    // Настройка интерсепторов
    instance.interceptors.request.use(
        (config) => {
            // проверка на наличие токена
            // if (token) {
            //   config.headers.Authorization = `Bearer ${token}`;
            // }
            return config;
        },
    );

    instance.interceptors.response.use(
        (response) => {
            return response.data;
        },

        async (error) => {
            const { showNotification } = useNotification();
            showNotification({
                type: 'danger',
                message: error.response.data,
            });
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest.isRetry) {
                originalRequest.isRetry = true;
                try {
                    // получить новый токен
                    return instance(originalRequest);
                } catch (e) {
                    // logout
                    return Promise.reject(e);
                }
            }
            return Promise.reject(error);
        },
    );

    return instance;
};

export const axiosInstance = createAxiosInstance();